import AchievementNotification from './AchievementNotification';

export default AchievementNotification;